"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const context_1 = __importDefault(require("./context"));
const FormProvider = ({ children }) => {
    const [errors, setErrors] = (0, react_1.useState)({});
    const [fields, setFields] = (0, react_1.useState)({});
    const [schema, setSchemaFields] = (0, react_1.useState)({});
    const setError = (name, error) => {
        setErrors((prevState) => {
            return {
                ...prevState,
                [name]: error,
            };
        });
    };
    const setDefaultError = (name, error) => {
        (0, react_1.useEffect)(() => setError(name, error), []);
    };
    const clearAllErrors = () => {
        setErrors({});
    };
    const clearError = (name) => {
        if (errors[name]) {
            setErrors((prevState) => {
                const newState = { ...prevState };
                delete newState[name];
                return newState;
            });
        }
    };
    const updateField = (name, field) => {
        setFields((prevState) => {
            return {
                ...prevState,
                [name]: field,
            };
        });
    };
    const setFieldValue = (name, value) => {
        updateField(name, {
            ...fields[name],
            data: value,
        });
    };
    const setFieldOptions = (name, options) => {
        updateField(name, {
            ...fields[name],
            options: {
                ...fields[name]?.options,
                ...options,
            },
        });
    };
    const setField = (name, field) => {
        (0, react_1.useEffect)(() => updateField(name, field), [schema]);
    };
    const updateSchemaField = (name, options) => {
        setSchemaFields((prevState) => {
            return {
                ...prevState,
                [name]: options,
            };
        });
    };
    const setSchemaField = (name, options) => {
        (0, react_1.useEffect)(() => updateSchemaField(name, options), []);
    };
    const setSchema = (schema) => {
        (0, react_1.useEffect)(() => setSchemaFields(schema), []);
    };
    const value = {
        errors,
        fields,
        schema,
        actions: {
            setField,
            setFieldValue,
            setFieldOptions,
            setSchema,
            setSchemaField,
            setError,
            setDefaultError,
            clearError,
            clearAllErrors,
        },
    };
    return (0, jsx_runtime_1.jsx)(context_1.default.Provider, { value: value, children: children });
};
exports.default = FormProvider;
